import styled from "styled-components";
import { theme } from "../theme";

export const StyledNav = styled.nav`
	background: ${theme.color.white};
	padding: 0.8rem 3rem;
	box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
	display: grid;
	grid-template-columns: 16rem 83rem 16rem;
	column-gap: 2rem;
	align-content: center;
	align-items: center;
	justify-content: space-between;
	z-index: 100;
	position: relative;
	
	/* Shift the search column slightly left */
	& > *:nth-child(2) {
		padding-right: 1rem;
	}
`;
